// extracted by mini-css-extract-plugin
module.exports = {"label":"e_Fv","disc":"e_Gv","glyph":"e_Hv","labelButton":"e_Iv","tip":"e_Jv","labelOpen":"e_Kv"};